import type React from 'react';

import { Image } from '@change-corgi/design-system-legacy/components/media';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export const Photo: React.FC<Props> = ({ id, url, mobileUrl }) => {
	const isSunriseTheme = useIsSunriseTheme();

	return (
		<Image
			fetchPriority="high"
			// The ratio we generate from uploaded images
			aspectRatio="25/14"
			fit="cover"
			width="100%"
			id={id}
			src={[mobileUrl, url]}
			alt=""
			sx={{
				borderRadius: isSunriseTheme ? 'big' : 'standard',
				// removes an unwanted padding under the image
				verticalAlign: 'top',
			}}
		/>
	);
};
